import { styled } from "@mui/system";
import { InputLabel } from "@mui/material";


export const BrandInput = styled(InputLabel)(() => ({
    width: "100%",
}));